import React from 'react';
import {
  Assessment as CarbonAssessmentNavIcon,
  Business as OrganizationNavIcon,
  Description as DocumentsNavIcon,
  Grass as CarbonInventoryNavIcon,
  HelpOutline as HelpIcon,
  Home as HomeNavIcon,
  InfoOutlined as InfoIcon,
  Payment as BillingNavIcon,
  CurrencyRupee as PricingNavIcon,
  Security as PrivacyIcon,
  Badge as ProfileNavIcon,
  Settings as SettingsNavIcon,
  Summarize as ReportsNavIcon,
  Gavel as ComplianceNavIcon,
  TrendingDown as EmissionsTargetsNavIcon,
  Storefront as MarketplaceNavIcon,
  SmartToyOutlined as SmartToyOutlinedIcon,
} from '@mui/icons-material';
import {
  ENTERPRISE_PRIMARY_NAV_TOPICS,
  ENTERPRISE_SECONDARY_NAV_TOPICS,
} from '../constants/enterpriseNavigation';
import {
  isEnterpriseAppPath,
  isNavPathActive,
  isTopicActive,
  NavTopic,
  PRIMARY_NAV_TOPICS,
  SECONDARY_NAV_TOPICS,
} from '../constants/appNavigation';

const TOPIC_ICONS: Record<string, React.ReactElement> = {
  Home: <HomeNavIcon fontSize="small" />,
  'My company': <ProfileNavIcon fontSize="small" />,
  Organization: <OrganizationNavIcon fontSize="small" />,
  Data: <DocumentsNavIcon fontSize="small" />,
  'Emissions': <CarbonAssessmentNavIcon fontSize="small" />,
  'Carbon footprint': <CarbonAssessmentNavIcon fontSize="small" />,
  'AI Advisor': <SmartToyOutlinedIcon fontSize="small" />,
  'Offsets & credits': <MarketplaceNavIcon fontSize="small" />,
  'Reduce and offset': <EmissionsTargetsNavIcon fontSize="small" />,
  'Carbon picture': <CarbonAssessmentNavIcon fontSize="small" />,
  'Carbon Analytics': <CarbonAssessmentNavIcon fontSize="small" />,
  Marketplace: <MarketplaceNavIcon fontSize="small" />,
  'Carbon inventory': <CarbonInventoryNavIcon fontSize="small" />,
  'Emissions targets': <EmissionsTargetsNavIcon fontSize="small" />,
  'Reduction targets': <EmissionsTargetsNavIcon fontSize="small" />,
  'Carbon goal': <EmissionsTargetsNavIcon fontSize="small" />,
  Compliance: <ComplianceNavIcon fontSize="small" />,
  'Finance & incentives': <PricingNavIcon fontSize="small" />,
  Reports: <ReportsNavIcon fontSize="small" />,
  Pricing: <PricingNavIcon fontSize="small" />,
  Information: <InfoIcon fontSize="small" />,
  Billing: <BillingNavIcon fontSize="small" />,
  'Data privacy': <PrivacyIcon fontSize="small" />,
  'Data Privacy': <PrivacyIcon fontSize="small" />,
  Settings: <SettingsNavIcon fontSize="small" />,
  'Help center': <HelpIcon fontSize="small" />,
  'Help Center': <HelpIcon fontSize="small" />,
};

const NAV_TOPICS_MSME: NavTopic[] = [...PRIMARY_NAV_TOPICS, ...SECONDARY_NAV_TOPICS];
const NAV_TOPICS_ENTERPRISE: NavTopic[] = [
  ...ENTERPRISE_PRIMARY_NAV_TOPICS,
  ...ENTERPRISE_SECONDARY_NAV_TOPICS,
];

function findActiveTopic(pathname: string, search: string, topics: NavTopic[]): NavTopic | null {
  for (const topic of topics) {
    if (topic.children?.some((child) => isNavPathActive(pathname, search, child.path))) {
      return topic;
    }
  }
  return topics.find((topic) => isTopicActive(pathname, search, topic)) ?? null;
}

export function resolveActiveNavTopicLabel(pathname: string, search = ''): string {
  const path = pathname || '/';
  const topics = isEnterpriseAppPath(path) ? NAV_TOPICS_ENTERPRISE : NAV_TOPICS_MSME;
  return findActiveTopic(path, search, topics)?.label ?? 'Home';
}

export function resolveNavTopicIcon(label: string): React.ReactElement {
  return TOPIC_ICONS[label] ?? <HomeNavIcon fontSize="small" />;
}

export function resolveNavTopicIconForPath(pathname: string, search = ''): React.ReactElement {
  return resolveNavTopicIcon(resolveActiveNavTopicLabel(pathname, search));
}
